/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { useCallback } from 'react';
import { Box, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import appTheme from '../../common/theme/appTheme.json';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import {
  deleteMissionConfirmation,
  getMissionPlanById,
  deleteMissionPlanError,
} from '../../../store/missionPlans/actions';
import { selectMissionPlanById, selectUserId } from '../../../store';

const useStyles = makeStyles({
  buttonWrapper: {
    display: 'flex',
    flexBasis: '100%',
    justifyContent: 'center',
    paddingTop: '16px',
  },
});

export interface SaveDeleteButtonsProps {}

const SaveDeleteButtons = (props: SaveDeleteButtonsProps) => {
  const classes = useStyles();
  let dispatch = useDispatch();
  let missionPlanById = useSelector(selectMissionPlanById, shallowEqual);
  const userId = useSelector(selectUserId, shallowEqual);

  const handleDelete = useCallback(() => {
    if (userId) {
      dispatch(getMissionPlanById(userId, missionPlanById.id));
    } else {
      dispatch(deleteMissionPlanError({ message: 'Unable to delete mission plan. ID not known' }));
    }
    dispatch(deleteMissionConfirmation(true));
  }, [dispatch, userId, missionPlanById.id]);

  return (
    <React.Fragment>
      <Box className={classes.buttonWrapper}>
        <Button
          color="primary"
          variant="outlined"
          sx={{
            width: '31%',
            fontSize: appTheme.buttonFontSize,
            fontWeight: 500,
            color: '#ffffff',
            borderRadius: '18px',
            borderColor: appTheme.primaryTextColor,
            backgroundColor: appTheme.mptPrimaryBackgroundColor,
            '&:hover': { backgroundColor: appTheme.mptPrimaryBackgroundColor, borderColor: appTheme.primaryTextColor },
            marginRight: '2%',
          }}
          onClick={handleDelete}
        >
          Delete Mission Plan
        </Button>

        <Button
          color="primary"
          type="submit"
          sx={{
            width: '31%',
            fontSize: appTheme.buttonFontSize,
            fontWeight: 500,
            borderRadius: '18px',
            backgroundColor: appTheme.mptLightBlue,
            color: appTheme.darkGrayTextColor,
            marginLeft: '2%',
            '&:hover': { backgroundColor: appTheme.mptLightBlue },
          }}
        >
          Import Flight Info
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default SaveDeleteButtons;
